import { AdvancedSearchStringOperators, AdvancedSearchURLParamsUtils } from '@ingenico/react-ui/advanced-search';
import type { SvgName } from '@ingenico/react-ui/svg-asset';
import { AS_VIEW_FILTERS_QUERY_NAME } from '@ingenico/react-ui/utils';
import { openNewTab } from '@ingenico/react-utils/functions';
import type { DashboardRowDataType } from '../../model/merchant.model';

export function getSvgNameFromEntity(entityObj: DashboardRowDataType): SvgName {
  switch (entityObj.entity) {
    case 'devices': {
      return 'merchant-devices';
    }
    case 'users': {
      return 'merchant-users';
    }
    case 'transactions': {
      return 'merchant-transactions';
    }
    case 'tasks': {
      return 'merchant-tasks';
    }
    // Add more cases for other entities as needed
    default: {
      return 'ppaas-logo';
    } // If entity is not found, you can return ppaas-logo
  }
}

export function openNewTabAccordingEntity(
  dashboardRowData: DashboardRowDataType,
  fallbackEntityId: string,
  provisioningRoutePrefix: string,
): void {
  switch (dashboardRowData?.entity) {
    case 'devices': {
      const filterField = dashboardRowData.deviceFilterField ?? 'merchant.id';
      const filterValue = dashboardRowData.deviceFilterValue ?? fallbackEntityId;
      const filters = [
        {
          field: filterField,
          condition: AdvancedSearchStringOperators.Equals,
          criteria: filterValue,
        },
      ];

      const encodedFilters = AdvancedSearchURLParamsUtils.encodeFilters(filters);
      const url = `${provisioningRoutePrefix}/virtual-devices?${AS_VIEW_FILTERS_QUERY_NAME}=${encodedFilters}`;
      openNewTab(url);
      break;
    }
    case 'tasks': {
      const url = `${window.location.origin}/${dashboardRowData?.entity}?entityGuid=${fallbackEntityId}`;
      openNewTab(url);
      break;
    }
    default: {
      break;
    }
  }
}
